import { Stack, StackProps } from '@chakra-ui/react';
import * as React from 'react';

import type { AiSearchIndexKey } from '../../types';

export const RESULTS_LIST_LAYOUT: Record<
  AiSearchIndexKey,
  { spacing: StackProps['spacing'] }
> = {
  members: { spacing: '3' },
  organizations: { spacing: '3' },
  files: { spacing: '3' },
  posts: { spacing: '4' },
  events: { spacing: '2' },
  groups: { spacing: '3' },
  tags: { spacing: '3' },
};

export const ResultsListContainer: React.FC<{
  index: AiSearchIndexKey;
  children: React.ReactNode;
}> = ({ index, children }) => (
  <Stack spacing={RESULTS_LIST_LAYOUT[index].spacing}>{children}</Stack>
);
